import React, { useState, useEffect } from 'react'
import isNull from 'lodash/isNull'
import uniqueId from 'lodash/uniqueId'
import PropTypes from 'prop-types'

import IconClose from 'client/icons/Close'
import IconDone from 'client/icons/Done'
import { Container, Checkbox, Switch, Handle } from './styles'

const Toggle = ({ error, initialState, onSwitch }) => {
  const [isOn, setIsOn] = useState(initialState)
  const [id, setId] = useState(null)
  useEffect(() => {
    if (isNull(id)) {
      setId(uniqueId('switch-'))
    }
  }, [id])

  useEffect(() => {
    setIsOn(error ? !isOn : initialState)
  }, [initialState, error]) // eslint-disable-line react-hooks/exhaustive-deps

  function onToggle() {
    setIsOn(!isOn)
    onSwitch(!isOn)
  }

  // Label onClick: https://stackoverflow.com/questions/46993591/react-why-label-not-firing-onchange-for-checkbox

  return (
    <Container data-testid="switch-label" htmlFor={id} onClick={event => event.stopPropagation()}>
      <Switch isOn={isOn}>
        <Handle>{isOn ? <IconDone size={18} /> : <IconClose size={18} />}</Handle>
      </Switch>

      <Checkbox
        data-testid="switch"
        onChange={onToggle}
        id={id}
        type="checkbox"
        role="switch"
        aria-checked={isOn}
      />
    </Container>
  )
}

Toggle.propTypes = {
  error: PropTypes.bool,
  initialState: PropTypes.bool,
  onSwitch: PropTypes.func.isRequired,
}

export default Toggle
